import { HOST_OPEN, URL_API_ONBOARDING } from '@/common/env'
import QueryStringUtil from '@/common/query'

class CommonUtils {
  get isProdEnv(): boolean {
    return !URL_API_ONBOARDING.includes('dev.')
  }

  get isTestEnv(): boolean {
    return URL_API_ONBOARDING.includes('test.')
  }

  isApiUrl(url: string): boolean {
    try {
      const u = new URL(url)
      return URL_API_ONBOARDING.includes(u.host)
    } catch (e) {
      return false
    }
  }

  isValidUrl(url: string): boolean {
    try {
      const u = new URL(url)
      return u.protocol.startsWith('http')
    } catch (e) {
      return false
    }
  }

  get clickThrough(): boolean {
    if (QueryStringUtil.get('clickthrough')) {
      return true
    } else {
      return false
    }
  }

  dateOfBirthFromAge(age: number): string {
    const birthYear = new Date().getFullYear() - age
    return birthYear + '-01-01'
  }
}

export default new CommonUtils()
